import { DefChartOpts } from '@features/social-analysis/models/IChart';

export const emptyChartOpts: DefChartOpts = {
    chart: {
        height: 450,
        type: 'bar',
        animations: {
            enabled: false,
        },
    },
    series: [{ name: '', data: [null] }],
    xaxis: {
        tooltip: {
            enabled: false,
        },
        categories: [''],
    },
    yaxis: [{ title: { text: '' } }],
    dataLabels: {
        enabled: false,
    },
    stroke: {
        curve: 'smooth' as const,
        width: [10, 10],
    },
    markers: {
        // show: false,
        size: 0,
        strokeWidth: 0,
    },
    tooltip: { enabled: false },
    // annotations: {},
    colors: ['#FFFFFF'],
    fill: {
        colors: ['#FFFFFF'],
        opacity: 1,
    },
    legend: {
        show: false,
    },
};
